module.exports = __webpack_public_path__ + "static/media/Myntra.befcb4f4.png";